module.exports = __webpack_public_path__ + "img/architecture02.6743f98d.jpg";